import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Product } from '@shared/models';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { ProductCatalogueDirective } from '../../../shared/components/product-image/product-catalogue.directive';
import { LocalizePipe } from '../../../i18n/pipes/lozalize.pipe';

@Component({
    selector: 'app-product-thumbnail',
    templateUrl: './product-thumbnail.component.html',
    styleUrls: ['./product-thumbnail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, NgTemplateOutlet, NgClass, ProductCatalogueDirective, LocalizePipe],
})
export class ProductThumbnailComponent {
    private activatedRoute = inject(ActivatedRoute);

    @Input({ required: true }) isBig!: boolean;
    @Input({ required: true }) product!: Product;

    categorySlug = this.activatedRoute.snapshot.params['slug'];
}
